"use strict";

jQuery(document).ready(function ($) {
    var adpPopup = {};

    (function () {
        var $this;

        adpPopup = {
            sPrevious: window.scrollY,
            sDirection: "down",

            /*
             * Initialize
             */
            init: function (e) {
                $this = adpPopup;

                $this.popupInit(e);

                // Init events.
                $this.events(e);
            },

            /*
             * Events
             */
            events: function (e) {
                // Custom Events using event delegation
                $(document).on("click", ".popup-close", function(event) {
                    $this.closePopup(event);
                });
                $(document).on("click", ".popup-accept", function(event) {
                    $this.acceptPopup(event);
                });
                $(document).on("click", ".age-verification__popup-close", function(event) {
                    $this.agePopup(event);
                    $this.closePopup(event);
                });
                $(document).on("click", ".age-verification__button-no", function(event) {
                    $this.ageDeclined(event);
                });

                // Event delegation for dynamically loaded "Calculate" button
                $(document).on("click", "#calculate", function(event) {
                    event.preventDefault(); // Prevent any default form submission

                    // Ensure the event is within the popup
                    var calculatorEl = $(this).closest('#coverage-calculator');
                    if (!calculatorEl.length) {
                        return;
                    }

                    // Perform the calculation logic
                    try {
                        // Retrieve input values
                        var height = parseFloat(calculatorEl.find('#wall_height').val());
                        var width = parseFloat(calculatorEl.find('#wall_width').val());
                        var totalAreaInput = parseFloat(calculatorEl.find('#total-area').val());

                        var totalArea;
                        if (!isNaN(height) && !isNaN(width)) {
                            // Calculate total area using height and width
                            totalArea = height * width;
                            // Clear the total area input if dimensions are provided
                            calculatorEl.find('#total-area').val('');
                        } else if (!isNaN(totalAreaInput)) {
                            // Use the direct total area input if available
                            totalArea = totalAreaInput;
                            // Clear the wall dimensions if total area is provided
                            calculatorEl.find('#wall_height').val('');
                            calculatorEl.find('#wall_width').val('');
                        } else {
                            throw new Error('Please enter valid height and width, or total area.');
                        }

                        // Check if including 15% extra
                        var includeExtra = calculatorEl.find('#include-extra').is(':checked');
                        if (includeExtra) {
                            totalArea *= 1.15; // Add 15% extra
                        }

                        // Retrieve the coverage value
                        var sfCoverage = parseFloat(calculatorEl.data('sf-coverage'));
                        if (isNaN(sfCoverage) || sfCoverage <= 0) {
                            throw new Error('Invalid coverage value.');
                        }

                        // Calculate the total quantity required
                        var totalQuantity = Math.ceil(totalArea / sfCoverage);

                        // Update the results in the UI
                        calculatorEl.find('#calculated-area').text(totalArea.toFixed(2));
                        calculatorEl.find('#quantity-required').text(totalQuantity);

                        // Update the coverage per tile output
                        calculatorEl.find('#tile-coverage').text(sfCoverage.toFixed(2));

                        // Show the results section
                        calculatorEl.find('#results').show();
                        calculatorEl.find('#error-message').hide();
                    } catch (error) {
                        // Show error message
                        calculatorEl.find('#error-message').text(error.message).show();
                        calculatorEl.find('#results').hide();
                    }
                });

                // Clear inputs logic
                $(document).on('input', '#wall_height, #wall_width', function () {
                    // Clear the total area input if wall dimensions are being edited
                    $('#total-area').val('');
                });
                $(document).on('input', '#total-area', function () {
                    // Clear the wall dimensions inputs if total area is being edited
                    $('#wall_height, #wall_width').val('');
                });

                // Checking this will cause popup to close when user presses key.
                $(document).keyup(function (e) {
                    // Press ESC to Close.
                    if (e.key === "Escape") {
                        $('.popup-open[data-esc-close="true"]').each(function (index, popup) {
                            $this.closePopup(popup);
                        });
                    }

                    // Press F4 to Close.
                    if (e.key === "F4") {
                        $('.popup-open[data-f4-close="true"]').each(function (index, popup) {
                            $this.closePopup(popup);
                        });
                    }
                });

                // Checking this will cause popup to close when user clicks on overlay.
                $(document).on("click", ".popup-overlay", function (e) {
                    $('.popup-open[data-overlay-close="true"]').each(function (index, popup) {
                        $this.closePopup(popup);
                    });
                });
            },

            /*
             * Init popup elements
             */
            popupInit: function (e) {
                // Set scroll direction.
                $(document).on("scroll", function () {
                    let scrollCurrent = window.scrollY;

                    // Set scroll temporary vars.
                    if (scrollCurrent > $this.sPrevious) {
                        $this.sDirection = "down";
                    } else {
                        $this.sDirection = "up";
                    }

                    $this.sPrevious = scrollCurrent;
                });

                // Open popup
                $(".popup").each(function (index, popup) {
                    // Manual Launch.
                    if ("manual" === $(popup).data("open-trigger")) {
                        let selector = $(popup).data("open-manual-selector");

                        if (selector) {
                            $(selector).addClass("popup-trigger");

                            $(document).on("click", selector, function (e) {
                                e.preventDefault();

                                $(popup).removeClass("popup-already-opened");
                                if (e.currentTarget.classList.contains("popup") || $(e.currentTarget).parents('.popup').length > 0) {
                                    $this.closePopup(selector);
                                }
                                $this.openPopup(popup);
                            });
                        }
                    }

                    // Checks whether a popup should be displayed or not.
                    if (!$this.isAllowPopup(popup) && !$(popup).hasClass("age-verification")) {
                        return;
                    }

                    $this.openTriggerPopup(popup);
                });
            },

            /*
             * Open popup
             */
            openPopup: function (e) {
                let popup = e.originalEvent ? this : e;

                // Hide body scroll.
                if ($(popup).is('[data-body-scroll-disable="true"]')) {
                    $("body").addClass("popup-scroll-hidden");
                }

                // Set Cookie of Limit display.
                let limit = parseInt($this.getCookie("popup-" + $(popup).data("id")) || 0) + 1;
                $this.setCookie("popup-" + $(popup).data("id"), limit, {
                    expires: $(popup).data("limit-lifetime"),
                });

                if ($(popup).hasClass("popup-open")) {
                    return;
                }

                // Check already opened.
                if ($(popup).hasClass("popup-already-opened")) {
                    return;
                }

                // Display popup.
                $(popup).addClass("popup-open");

                // Set current scroll.
                $(popup).data("init-scroll-px", window.scrollY);
                $(popup).data("init-scroll-percent", $this.getScrollPercent());

                // Open animation.
                let animation = $(popup).data("open-animation");
                $this.applyAnimation(popup, animation);

                // Init close trigger.
                $this.closeTriggerPopup(popup);
            },

            /*
             * Close popup
             */
            closePopup: function (e) {
                let $el = e.originalEvent ? this : e;

                // Get popup container.
                let popup = $($el).closest(".popup");
                // Close animation.
                let animation = $(popup).data("exit-animation");

                $this.applyAnimation(popup, animation, function () {
                    // Already opened.
                    $(popup).addClass("popup-already-opened");

                    // Hide popup.
                    $(popup).removeClass("popup-open");

                });
                // Remove classes from body.
                $("body").removeClass("popup-scroll-hidden");
            },

            // Other methods remain unchanged...

        };
    })();

    // Initialize.
    adpPopup.init();

    document.addEventListener("shopify:section:load", function () {
        adpPopup.init();
    });
});
